class TurnoverReportUtil {
    getTotalVippsPickupCount(zReports){
        var totalVippsPickupCount = 0;
        for (var i = 0; i < zReports.length; i++) {
            var zReport = zReports[i].cagistahospitality;
            let vippsPickupCount = zReport.vippsPickupCount || 0;
            totalVippsPickupCount = totalVippsPickupCount + vippsPickupCount;
        }
        return totalVippsPickupCount;
    }

    getTotalVippsDineInCount(zReports){
        var totalVippsDineInCount = 0;
        for (var i = 0; i < zReports.length; i++) {
            var zReport = zReports[i].cagistahospitality;
            let vippsDineInCount = zReport.vippsDineInCount || 0;
            totalVippsDineInCount = totalVippsDineInCount + vippsDineInCount;
        }
        return totalVippsDineInCount;
    }

    getTotalVippsDeliveryCount(zReports){
        var totalVippsDeliveryCount = 0;
        for (var i = 0; i < zReports.length; i++) {
            var zReport = zReports[i].cagistahospitality;
            let vippsDeliveryCount = zReport.vippsDeliveryCount || 0;
            totalVippsDeliveryCount = totalVippsDeliveryCount + vippsDeliveryCount;
        }
        return totalVippsDeliveryCount;
    }

    getTotalVippsDeliveryServiceCount(zReports){
        var totalVippsDeliveryServiceCount = 0;
        for (var i = 0; i < zReports.length; i++) {
            var zReport = zReports[i].cagistahospitality;
            let vippsDeliveryServiceCount = zReport.vippsDeliveryServiceCount || 0;
            totalVippsDeliveryServiceCount = totalVippsDeliveryServiceCount + vippsDeliveryServiceCount;
        }
        return totalVippsDeliveryServiceCount;
    }

    getVippsTotalCount(zReports){
        return (this.getTotalVippsPickupCount(zReports) + this.getTotalVippsDineInCount(zReports) + this.getTotalVippsDeliveryCount(zReports) + this.getTotalVippsDeliveryServiceCount(zReports));
    }

    getTotalCardPickupCount(zReports){
        var totalCardPickupCount = 0;
        for (var i = 0; i < zReports.length; i++) {
            var zReport = zReports[i].cagistahospitality;
            totalCardPickupCount = totalCardPickupCount + zReport.cardPickupCount;
        }
        return totalCardPickupCount;
    }

    getTotalCardDineInCount(zReports){
        var totalCardDineInCount = 0;
        for (var i = 0; i < zReports.length; i++) {
            var zReport = zReports[i].cagistahospitality;
            totalCardDineInCount = totalCardDineInCount + zReport.cardDineInCount;
        }
        return totalCardDineInCount;
    }

    getTotalCardPickupBrutto(zReports){
        var totalCardPickupBrutto = 0;
        for (var i = 0; i < zReports.length; i++) {
            var zReport = zReports[i].cagistahospitality;
            totalCardPickupBrutto = totalCardPickupBrutto + zReport.cardPickupBrutto;
        }
        return totalCardPickupBrutto;
    }

    getTotalCardDeliveryCount(zReports){
        var totalCardDeliveryCount = 0;
        for (var i = 0; i < zReports.length; i++) {
            var zReport = zReports[i].cagistahospitality;
            totalCardDeliveryCount = totalCardDeliveryCount + zReport.cardDeliveryCount;
        }
        return totalCardDeliveryCount;
    }

    getTotalCardDeliveryAndDeliveryServiceBrutto(zReports){
        var totalCardDeliveryAndDeliveryServiceBrutto = 0;
        for (var i = 0; i < zReports.length; i++) {
            var zReport = zReports[i].cagistahospitality;
            totalCardDeliveryAndDeliveryServiceBrutto = totalCardDeliveryAndDeliveryServiceBrutto + zReport.cardDeliveryBrutto + zReport.cardDeliveryServiceBrutto;
        }
        return totalCardDeliveryAndDeliveryServiceBrutto;
    }

    getCardTotalCount(zReports){
        // Include legacy Vipps counts as card counts
        let vippsTotalCount = this.getVippsTotalCount(zReports);
        return (this.getTotalCardPickupCount(zReports) + this.getTotalCardDineInCount(zReports) + this.getTotalCardDeliveryCount(zReports) + vippsTotalCount);
    }

    getTotalCashPickupCount(zReports){
        var totalCashPickupCount = 0;
        for (var i = 0; i < zReports.length; i++) {
            var zReport = zReports[i].cagistahospitality;
            totalCashPickupCount = totalCashPickupCount + zReport.cashPickupCount;
        }
        return totalCashPickupCount;
    }

    getTotalCashDineInCount(zReports){
        var totalCashDineInCount = 0;
        for (var i = 0; i < zReports.length; i++) {
            var zReport = zReports[i].cagistahospitality;
            totalCashDineInCount = totalCashDineInCount + zReport.cashDineInCount;
        }
        return totalCashDineInCount;
    }

    getTotalCashDeliveryCount(zReports){
        var totalCashDeliveryCount = 0;
        for (var i = 0; i < zReports.length; i++) {
            var zReport = zReports[i].cagistahospitality;
            totalCashDeliveryCount = totalCashDeliveryCount + zReport.cashDeliveryCount;
        }
        return totalCashDeliveryCount;
    }

    getCashTotalCount(zReports){
        return (this.getTotalCashPickupCount(zReports) + this.getTotalCashDineInCount(zReports) + this.getTotalCashDeliveryCount(zReports));
    }

    getTotalBankAxeptPickupCount(zReports){
        let totalBankAxeptPickupCount = 0;
        for (let i = 0; i < zReports.length; i++) {
            let zReport = zReports[i].cagistahospitality;
            let bankAxeptPickupCount = zReport.bankAxeptPickupCount ? zReport.bankAxeptPickupCount : 0;
            totalBankAxeptPickupCount = totalBankAxeptPickupCount + bankAxeptPickupCount;
        }
        return totalBankAxeptPickupCount;
    }

    getTotalBankAxeptDineInCount(zReports){
        let totalBankAxeptDineInCount = 0;
        for (let i = 0; i < zReports.length; i++) {
            let zReport = zReports[i].cagistahospitality;
            let bankAxeptDineInCount = zReport.bankAxeptDineInCount ? zReport.bankAxeptDineInCount : 0;
            totalBankAxeptDineInCount = totalBankAxeptDineInCount + bankAxeptDineInCount;
        }
        return totalBankAxeptDineInCount;
    }

    getTotalBankAxeptDeliveryCount(zReports){
        let totalBankAxeptDeliveryCount = 0;
        for (let i = 0; i < zReports.length; i++) {
            let zReport = zReports[i].cagistahospitality;
            let bankAxeptDeliveryCount = zReport.bankAxeptDeliveryCount ? zReport.bankAxeptDeliveryCount : 0;
            totalBankAxeptDeliveryCount = totalBankAxeptDeliveryCount + bankAxeptDeliveryCount;
        }
        return totalBankAxeptDeliveryCount;
    }

    getBankAxeptTotalCount(zReports){
        return (this.getTotalBankAxeptPickupCount(zReports) + this.getTotalBankAxeptDineInCount(zReports) + this.getTotalBankAxeptDeliveryCount(zReports));
    }

    getLoyaltyPointsTotalCount(zReports){
        let totalLoyaltyPointsCount = 0;
        for (let i = 0; i < zReports.length; i++) {
            let zReport = zReports[i].cagistahospitality;
            let loyaltyPointsCount = zReport.loyaltyPointsCount ? zReport.loyaltyPointsCount : 0;
            totalLoyaltyPointsCount = totalLoyaltyPointsCount + loyaltyPointsCount;
        }
        return totalLoyaltyPointsCount;
    }

    getCardTotalBrutto(zReports){
        var cardTotalBrutto = 0;
        for (var i = 0; i < zReports.length; i++) {
            var zReport = zReports[i].cagistahospitality;
            cardTotalBrutto = cardTotalBrutto + zReport.cardPickupBrutto + zReport.cardDeliveryBrutto + zReport.cardDeliveryServiceBrutto;
        }
        return Math.round(cardTotalBrutto);
    }

    getTotalTakeawayVat(zReports){
        var totalTakeawayVat = 0;
        for (var i = 0; i < zReports.length; i++) {
            var zReport = zReports[i].cagistahospitality;
            var cashPickupVat = zReport.cashPickupVat;
            var cashDeliveryVat = zReport.cashDeliveryVat;
            var vippsPickupVat = zReport.vippsPickupVat;
            var vippsDeliveryVat = zReport.vippsDeliveryVat;
            var cardPickupVat = zReport.cardPickupVat;
            var cardDeliveryVat = zReport.cardDeliveryVat;
            totalTakeawayVat = totalTakeawayVat + Math.round(cashPickupVat + cashDeliveryVat+ vippsPickupVat + vippsDeliveryVat + cardPickupVat + cardDeliveryVat);
        }
        return totalTakeawayVat;
    }

    getTotalTakeawayBrutto(zReports){
        var totalTakeawayBrutto = 0;
        for (var i = 0; i < zReports.length; i++) {
            var zReport = zReports[i].cagistahospitality;
            var cashPickupBrutto = zReport.cashPickupBrutto;
            var cashDeliveryBrutto = zReport.cashDeliveryBrutto;
            var vippsPickupBrutto = zReport.vippsPickupBrutto;
            var vippsDeliveryBrutto = zReport.vippsDeliveryBrutto;
            var cardPickupBrutto = zReport.cardPickupBrutto;
            var cardDeliveryBrutto = zReport.cardDeliveryBrutto
            totalTakeawayBrutto = totalTakeawayBrutto + cashPickupBrutto + cashDeliveryBrutto + vippsPickupBrutto + vippsDeliveryBrutto + cardPickupBrutto + cardDeliveryBrutto;
        }
        return totalTakeawayBrutto
    }

    getTotalTakeawayNetto(zReports){
        return (this.getTotalTakeawayBrutto(zReports) - this.getTotalTakeawayVat(zReports));
    }

    getTotalDineInAndServiceVat(zReports){
        var totalDineInAndServiceVat = 0;
        for (var i = 0; i < zReports.length; i++) {
            var zReport = zReports[i].cagistahospitality;
            var cashDineInVat = zReport.cashDineInVat;
            var cashDeliveryServiceVat = zReport.cashDeliveryServiceVat;
            var vippsDineInVat = zReport.vippsDineInVat;
            var vippsDeliveryServiceVat = zReport.vippsDeliveryServiceVat;
            var cardDineInVat = zReport.cardDineInVat;
            var cardDeliveryServiceVat = zReport.cardDeliveryServiceVat;
            totalDineInAndServiceVat = totalDineInAndServiceVat + Math.round(cashDineInVat + cashDeliveryServiceVat + vippsDineInVat + vippsDeliveryServiceVat + cardDineInVat + cardDeliveryServiceVat);
        }
        return totalDineInAndServiceVat;
    }

    getTotalDineInAndServiceBrutto(zReports){
        var totalDineInAndServiceBrutto = 0;
        for (var i = 0; i < zReports.length; i++) {
            var zReport = zReports[i].cagistahospitality;
            var cashDineInBrutto = zReport.cashDineInBrutto;
            var cashDeliveryServiceBrutto = zReport.cashDeliveryServiceBrutto;
            var vippsDineInBrutto = zReport.vippsDineInBrutto;
            var vippsDeliveryServiceBrutto = zReport.vippsDeliveryServiceBrutto;
            var cardDineInBrutto = zReport.cardDineInBrutto;
            var cardDeliveryServiceBrutto = zReport.cardDeliveryServiceBrutto;
            totalDineInAndServiceBrutto = totalDineInAndServiceBrutto + cashDineInBrutto + cashDeliveryServiceBrutto + vippsDineInBrutto + vippsDeliveryServiceBrutto + cardDineInBrutto + cardDeliveryServiceBrutto;
        }
        return totalDineInAndServiceBrutto;
    }

    getTotalDineInAndServiceNetto(zReports){
        return (this.getTotalDineInAndServiceBrutto(zReports) - this.getTotalDineInAndServiceVat(zReports));
    }

    getTotalSalesVat(zReports){
        return (this.getTotalTakeawayVat(zReports) + this.getTotalDineInAndServiceVat(zReports));
    }

    getTotalSalesNetto(zReports){
        return (this.getTotalTakeawayNetto(zReports) + this.getTotalDineInAndServiceNetto(zReports));
    }

    getTotalSalesBrutto(zReports){
        return (this.getTotalTakeawayBrutto(zReports) + this.getTotalDineInAndServiceBrutto(zReports));
    }
}

export default new TurnoverReportUtil();
